// Was `getLocationPath(0, r)` imported from '@symbo.ls/router' — that
// package has never exported a `getLocationPath` (only `getActiveRoute`,
// front-indexed, different semantics), so every export below threw at call
// time and was excluded from the `functions/index.js` barrel (frank
// `dropped-export`, 14 findings, 2026-08-09 frank-compile pass). The real
// last-path-segment helper is local (`./getLastLocationPath.js`, level 0 =
// last segment); importing a sibling project file directly is against the
// sibling-import rule (same call already made in `component.js`'s
// `goToRemovedComponentEditorRoute`), so inline the (level 0, `r` or
// `window.location.pathname`) case every export here needs.
//
// FA204 / frank trap — `_lastRouteSegment` used to be a single module-scope
// const shared by every export below; unresolvable once each export is
// individually frank.toJSON'd for platform delivery
// (project_frank_drops_module_local_helpers). Each export now carries its
// own self-contained inline copy.

export const isDesignSystemRouteActive = (r) => {
  const _lastRouteSegment = (r) => {
    const route = r || window.location.pathname
    const parts = route.split('/')
    const seg = parts[parts.length - 1]
    return seg ? `/${seg}` : undefined
  }
  const route = _lastRouteSegment(r) || ''
  return [
    '/design-system',
    '/typography',
    '/color',
    '/icons',
    '/shape',
    '/font',
    '/timing',
    '/theme',
    '/cases',
    '/media',
    '/grid',
    '/spacing'
  ].includes(route)
}

export const isStateRouteActive = (r) => {
  const _lastRouteSegment = (r) => {
    const route = r || window.location.pathname
    const parts = route.split('/')
    const seg = parts[parts.length - 1]
    return seg ? `/${seg}` : undefined
  }
  const route = _lastRouteSegment(r) || ''
  return ['/state', '/data'].includes(route)
}

export const isLibraryComopnentRouteActive = (r) => {
  const _lastRouteSegment = (r) => {
    const route = r || window.location.pathname
    const parts = route.split('/')
    const seg = parts[parts.length - 1]
    return seg ? `/${seg}` : undefined
  }
  const route = _lastRouteSegment(r) || ''
  return (
    ['/editor', '/export'].includes(route) || (r || window.location.pathname).includes('/editor')
  )
}

export const isPreviewComponentRouteActive = (r) => {
  const _lastRouteSegment = (r) => {
    const route = r || window.location.pathname
    const parts = route.split('/')
    const seg = parts[parts.length - 1]
    return seg ? `/${seg}` : undefined
  }
  const route = _lastRouteSegment(r) || ''
  return ['/component'].includes(route)
}

export const isLibraryRouteActive = (r) => {
  const _lastRouteSegment = (r) => {
    const route = r || window.location.pathname
    const parts = route.split('/')
    const seg = parts[parts.length - 1]
    return seg ? `/${seg}` : undefined
  }
  const route = _lastRouteSegment(r) || ''
  return (
    [
      '/component',
      '/components',
      '/layouts',
      '/atoms',
      '/layout',
      '/blocks',
      '/block',
      '/export',
      '/editor',
      '/marketplace',
      '/library'
    ].includes(route) || (r || window.location.pathname).includes('/editor')
  )
}

export const isPagesRouteActive = (r) => {
  const _lastRouteSegment = (r) => {
    const route = r || window.location.pathname
    const parts = route.split('/')
    const seg = parts[parts.length - 1]
    return seg ? `/${seg}` : undefined
  }
  const route = _lastRouteSegment(r) || ''
  return ['/pages', '/page'].includes(route)
}

export const isSnippetsRouteActive = (r) => {
  const _lastRouteSegment = (r) => {
    const route = r || window.location.pathname
    const parts = route.split('/')
    const seg = parts[parts.length - 1]
    return seg ? `/${seg}` : undefined
  }
  const route = _lastRouteSegment(r) || ''
  return ['/functions'].includes(route)
}

export const isTutorialsRouteActive = (r) => {
  const _lastRouteSegment = (r) => {
    const route = r || window.location.pathname
    const parts = route.split('/')
    const seg = parts[parts.length - 1]
    return seg ? `/${seg}` : undefined
  }
  const route = _lastRouteSegment(r) || ''
  return ['/tutorials', '/tutorial'].includes(route)
}

export const isFilesRouteActive = (r) => {
  const _lastRouteSegment = (r) => {
    const route = r || window.location.pathname
    const parts = route.split('/')
    const seg = parts[parts.length - 1]
    return seg ? `/${seg}` : undefined
  }
  const route = _lastRouteSegment(r) || ''
  return ['/files'].includes(route)
}

export const isFileRouteActive = (r) => (r || window.location.pathname).includes('/edit-file')

export const isStudioRouteActive = (r) => (r || window.location.pathname).includes('/studio')

export const isSettingsRouteActive = (r) => {
  const _lastRouteSegment = (r) => {
    const route = r || window.location.pathname
    const parts = route.split('/')
    const seg = parts[parts.length - 1]
    return seg ? `/${seg}` : undefined
  }
  const route = _lastRouteSegment(r) || ''
  return ['/schema', '/settings'].includes(route)
}

export const isIntegrationsRouteActive = (r) => {
  const _lastRouteSegment = (r) => {
    const route = r || window.location.pathname
    const parts = route.split('/')
    const seg = parts[parts.length - 1]
    return seg ? `/${seg}` : undefined
  }
  const route = _lastRouteSegment(r) || ''
  return ['/integrations', '/install', '/connect'].includes(route)
}

export const isDocsRouteActive = (r) => {
  const _lastRouteSegment = (r) => {
    const route = r || window.location.pathname
    const parts = route.split('/')
    const seg = parts[parts.length - 1]
    return seg ? `/${seg}` : undefined
  }
  const route = _lastRouteSegment(r) || ''
  return [
    '/index',
    '/api',
    '/tutorials',
    '/cli',
    '/developers',
    '/playground',
    '/convert',
    '/docs'
  ].includes(route)
}
